import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        window.history.replaceState({}, "", "/portal");
        const target = data.role && data.role !== "client" ? "/admin" : "/portal";
        navigate(target, { replace: true, state: { user: data } });
      } catch (e) {
        console.error(e);
        navigate("/", { replace: true });
      }
    })();
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6]" data-testid="auth-callback">
      <div className="text-center">
        <img src="/logo.png" alt="Jay's" className="h-16 mx-auto mb-4 animate-pulse" />
        <p className="text-sm text-[#4b5563]">Signing you in…</p>
      </div>
    </div>
  );
}
